import {createSlice, PayloadAction} from '@reduxjs/toolkit';
// Interface for the slice state
import {
  UserDetail,
  ValidationErrors,
} from '../../components/bulk-user-upload-module/models';
interface UserState {
  errorSummary: {
    totalError: number;
    totalUsers: number;
  };
  client: {
    clientId: string;
    clientName: string;
  };
  users: UserDetail[];
  totalRecord: number;
  totalUserHasError: number;
  totalError: number;
  validationErrors: ValidationErrors | null;
  triggerUserDataAPI: boolean;
}

// Initial state
const initialState: UserState = {
  errorSummary: {
    totalError: 0,
    totalUsers: 0,
  },
  client: {
    clientId: '',
    clientName: '',
  },
  users: [],
  totalRecord: 100,
  totalUserHasError: 20,
  totalError: 2220,
  validationErrors: null,
  triggerUserDataAPI: false,
};

// Create the slice
const userResultScreenSlice = createSlice({
  name: 'userResultScreen',
  initialState,
  reducers: {
    setUsers: (state, action: PayloadAction<UserDetail[]>) => {
      state.users = action.payload;
    },
    setTotalRecord: (state, action: PayloadAction<number>) => {
      state.totalRecord = action.payload;
    },
    setTotalUserHasError: (state, action: PayloadAction<number>) => {
      state.totalUserHasError = action.payload;
    },
    setTotalError: (state, action: PayloadAction<number>) => {
      state.totalError = action.payload;
    },
    setValidationErrors: (state, action: PayloadAction<ValidationErrors>) => {
      state.validationErrors = action.payload;
    },
    resetState: (state) => {
      state.users = [];
      state.totalRecord = 75;
      state.totalUserHasError = 25;
      state.totalError = 0;
      state.validationErrors = null;
    },
    setTriggerUserDataAPI: (state, action: PayloadAction<boolean>) => {
      state.triggerUserDataAPI = action.payload;
    },
  },
});

// Export the actions
export const {
  setUsers,
  setTriggerUserDataAPI,
  setTotalRecord,
  setTotalUserHasError,
  setTotalError,
  setValidationErrors,
  resetState,
} = userResultScreenSlice.actions;

// Export the reducer
export default userResultScreenSlice.reducer;
